<template>
  <SimpleEmailForm :error="error" :is-loading="isLoading" @send="send" />
</template>
<script>
import { mapGetters } from "vuex";
import api from "./api/coating";
import SimpleEmailForm from "../SimpleEmailForm.vue";

export default {
  name: "CoatingCalculatorEmailForm",

  components: { SimpleEmailForm },

  props: {
    coating: {
      type: Object,
      required: true,
    },
    isInterior: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      error: false,
      isLoading: false,
    };
  },

  computed: {
    ...mapGetters("coatingCalculator", [
      "totalInteriorQuantity",
      "totalExteriorQuantity",
    ]),

    quantity() {
      return this.isInterior
        ? this.totalInteriorQuantity
        : this.totalExteriorQuantity;
    },
  },

  methods: {
    async send(email) {
      if (this.isLoading) return;

      this.error = false;
      this.isLoading = true;

      const { coating, quantity } = this;

      try {
        await api.send({ coating, quantity, email });
        this.isLoading = false;
        this.$emit("close");
      } catch (err) {
        this.error = err.message;
        this.isLoading = false;
      }
    },
  },
};
</script>
